import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IWbpDetail, IWbpSearch, IWbpInsert } from "./wbpTypes";


class WbpService {
    async page(searchVo: IWbpSearch, config: object = {}) {
        const apiUrl = "/gtm/warning/agreement/search/pg";
        return await httpRequest.post<IPage<IWbpDetail>>(apiUrl, searchVo, config);
    }

    async insert(insertVo:IWbpInsert){
        const apiUrl = "/gtm/warning/agreement/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //导出
    async export(searchVo: IWbpSearch) {
        const appPageUrl = "/gtm/warning/agreement/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
}

export const wbpService = new WbpService();
